export const GET_HOME_OWNER_LIST_ASYNC = 'GET_HOME_OWNER_LIST_ASYNC';
export const GET_HOME_OWNER_LIST_SUCCESS = 'GET_HOME_OWNER_LIST_SUCCESS';
export const GET_HOME_OWNER_LIST_FAIL = 'GET_HOME_OWNER_LIST_FAIL';

export const EDIT_HOME_OWNER_INFO_ASYNC = 'EDIT_HOME_OWNER_INFO_ASYNC';
export const EDIT_HOME_OWNER_INFO_SUCCESS = 'EDIT_HOME_OWNER_INFO_SUCCESS';
export const EDIT_HOME_OWNER_INFO_FAIL = 'EDIT_HOME_OWNER_INFO_FAIL';

export const GET_SELECT_LIST_HOMEOWNER_ASYNC = 'GET_SELECT_LIST_HOMEOWNER_ASYNC';
export const GET_SELECT_LIST_HOMEOWNER_SUCCESS = 'GET_SELECT_LIST_HOMEOWNER_SUCCESS';

export const SEARCH_CURRENT_ASSIGNED_LOT_ASYNC = 'SEARCH_CURRENT_ASSIGNED_LOT_ASYNC';
export const SEARCH_CURRENT_ASSIGNED_LOT_SUCCESS = 'SEARCH_CURRENT_ASSIGNED_LOT_SUCCESS';
export const SEARCH_FORMER_ASSIGNED_LOT_ASYNC = 'SEARCH_FORMER_ASSIGNED_LOT_ASYNC';
export const SEARCH_FORMER_ASSIGNED_LOT_SUCCESS = 'SEARCH_FORMER_ASSIGNED_LOT_SUCCESS';
export const SEARCH_TENANCY_ASSIGNED_LOT_ASYNC = 'SEARCH_TENANCY_ASSIGNED_LOT_ASYNC';
export const SEARCH_TENANCY_ASSIGNED_LOT_SUCCESS = 'SEARCH_TENANCY_ASSIGNED_LOT_SUCCESS';

export const RESET_HOMEOWNER_LIST = 'RESET_HOMEOWNER_LIST';

export const GET_HOMEOWNER_PROFILE_ASYNC = 'GET_HOMEOWNER_PROFILE_ASYNC';
export const GET_HOMEOWNER_PROFILE_SUCCESS = 'GET_HOMEOWNER_PROFILE_SUCCESS';
export const SEARCH_HOME_OWNER_SUCCESS = 'SEARCH_HOME_OWNER_SUCCESS';



// WEBPACK FOOTER //
// ./src/HomeOwners/constants.js